import SiteNav from "./components/SiteNav";
import Hero from "./components/Hero";
import OverviewSection from "./components/OverviewSection";
import CollectionsSection from "./components/CollectionsSection";
import AdaptationsSection from "./components/AdaptationsSection";
import SeriesSection from "./components/SeriesSection";
import TvSection from "./components/TvSection";
import TimelineSection from "./components/TimelineSection";
import RecommendSection from "./components/RecommendSection";
import GuideSection from "./components/GuideSection";
import FaqSection from "./components/FaqSection";
import SiteFooter from "./components/SiteFooter";

export default function Home() {
  return (
    <div className="w-full min-h-screen bg-background-50">
      <SiteNav />
      <main className="w-full">
        <Hero />
        <OverviewSection />
        <CollectionsSection />
        <AdaptationsSection />
        <SeriesSection />
        <TvSection />
        <TimelineSection />
        <RecommendSection />
        <GuideSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}